<section class="video-card" (click)="onVideoClick(video)">

  <div class="thumbnail-wrapper" style="position: relative;">
    <app-video-thumbnail [video]="video"> </app-video-thumbnail>

    @if (video && !video.team_check_completed) {
    <div class="team-pending-badge" title="Equipos sin configurar"
      style="position: absolute; top: 8px; left: 8px; z-index: 10; background: rgba(0,0,0,0.6); padding: 6px; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
      <img src="assets/static/icons/team-pending.svg" width="20">
    </div>
    }

    @if (!isLoading() && isInternalUser) {
    <button class="delete-btn" (click)="onDeleteClick($event)" title="Eliminar video">
      <img src="assets/static/icons/delete.svg" alt="Eliminar" width="20">
    </button>
    }
  </div>

  <app-video-metadata [video]="video">
    <p middle-content class="video-card-title">
      @if (isLoading()) {
      <span>
        <span class="skeleton"> Loading video title, please wait... </span>
      </span>
      } @else {
      <span class="text">{{ video.title }}</span>
      }
    </p>
  </app-video-metadata>
</section>